<p id="name">{{product.name}}</p>
<iframe [width]="886 / 2" [height]="886" *ngIf="videoUrl" [src]=videoUrl frameborder="0" allow="autoplay"></iframe>
<p id="description">{{product.description}}</p>
<p id="comment">{{product.comment}}</p>

<app-store-buttons [googlePlayStore]=product.googlePlayStoreUrl [appleAppStore]=product.appleAppStoreUrl>
</app-store-buttons>